export enum IMAGE_MEDIA_TYPE {
  CLOUDINARY = 'CLOUDINARY',
  REMOTE = 'REMOTE',
  INVALID = 'INVALID'
}
